module.exports = __webpack_public_path__ + "static/footer-city-drawing-53bd387c60764a2dd5fb93fa02af66e6.png";